import css from './images/css.png';
import git from './images/git.png';
import html from './images/html.png';
import javaScript from './images/javaScript.png';
import jest from './images/jest.png';
import mySql from './images/mySql.png';
import nextJs from './images/nextJs.png';
import nodejs from './images/node-js.png';
import reac from './images/reac.png';
import react from './images/react.png';
import reactTesting from './images/reactTesting.png';
import redux from './images/redux.png';
import styledC from './images/styledC.png';
import typesS from './images/typesS.png';

export const Data = [
    {
        img: css
    },
    {
        img: git
    },
    {
        img: javaScript
    },
    {
        img: html
    },
    {
        img: jest
    },
    {
        img: mySql
    },
    {
        img: nextJs
    },
    {
        img: nodejs
    },
    {
        img: reac
    },
    {
        img: react
    },
    {
        img: reactTesting
    },
    {
        img: redux
    },
    {
        img: typesS
    },
    {
        img: styledC
    }
]